require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#ed5ba0',
        accent: '#2dacd4',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
      dark: {
        primary: '#f18eba',
        accent: '#2cacd4',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
    },
  },
}
